<template>
  <div class="w-full bg-white shadow-lg">
    <div class="pb-6">
      <div class="bg-primary flex pl-4">
        <feather-icon
          icon="ListIcon"
          class="cursor-pointer my-auto text-white"
        ></feather-icon>
        <p class="text-white font-bold text-xl py-4 pl-4">Contents</p>
      </div>
      <div class="rounded-lg eightyvh cust-overflow-y-primary-color">
        <div
          class="items-center cursor-pointer pt-1"
          v-for="(item, index) in chapter"
          :key="'item -' + index"
        >
          <div
            v-b-toggle="'collapse-' + index"
            class="cardbody-p border-b-2 rounded-md mx-2 px-2 py-3"
          >
            <div class="flex w-full">
              <div class="flex width5">
                <feather-icon
                  icon="ChevronDownIcon"
                  class="cursor-pointer w-3 h-3 pt-px"
                  v-if="!isCollapseVisible"
                ></feather-icon>
                <feather-icon
                  icon="ChevronUpIcon"
                  class="cursor-pointer w-3 h-3"
                  v-else
                ></feather-icon>
              </div>
              <div class="my-auto width65">
                <p class="font-semibold text-md text-black pl-4 items-center">
                  {{ item.name }}
                </p>
              </div>
              <!-- <div class="font-thin text-right pr-2 text-sm my-auto">
                00hr 15min
              </div> -->
            </div>
            <b-collapse :id="'collapse-' + index" class="bg-white mt-2 w-full">
              <div class="w-full items-center rounded-lg">
                <div
                  class="flex justify-between"
                  v-for="(items, index) in item.topic"
                  :key="'item -' + index"
                >
                  <div class="flex items-baseline py-2">
                    <div class="mr-2 ml-2 my-auto">
                      <!-- <feather-icon
                        icon="PlayCircleIcon"
                        class="cursor-pointer playicon-cust"
                      ></feather-icon> -->
                      <label class="custom-checkbox mb-0" id="allcheck">
                        <input type="checkbox" />
                        <span class="checkmark"></span>
                      </label>
                    </div>
                    <div class="pl-2" @click="getTopic(items)">
                      <p class="font-semibold text-md">
                        {{ items.name }}
                      </p>
                      <div class="flex mt-1 custom-mt">
                        <feather-icon
                          v-if="items.docType == 'video'"
                          icon="PlayCircleIcon"
                          class="cursor-pointer playicon-cust"
                        ></feather-icon>
                        <feather-icon
                          v-else-if="items.docType == 'pdf'"
                          icon="FileIcon"
                          class="cursor-pointer playicon-cust"
                        ></feather-icon>
                        <p
                          class="font-thin ml-2 text-sm my-auto"
                          v-if="items.docType != 'pdf'"
                        >
                          {{ Math.floor(items.duration / 60 / 60) }}h{{
                            Math.floor(items.duration / 60) -
                            Math.floor(items.duration / 60 / 60) * 60
                          }}m{{ items.duration % 60 }}s
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="flex mt-1 items-center pl-2">
                  <label class="custom-checkbox mb-0" id="allcheck">
                    <input type="checkbox" />
                    <span class="checkmark"></span>
                  </label>
                  <feather-icon
                    icon="ClipboardIcon"
                    class="cursor-pointer playicon-cust pl-6 mr-2"
                    svgClasses="w-4 h-4"
                  ></feather-icon>
                  <p>Assignment</p>
                </div> -->
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isCollapseVisible: false,
      courseChapter: [
        {
          chapter: "hello world programme",
        },
        {
          chapter: "print even Number",
        },
        {
          chapter: "Palindrome code",
        },
        {
          chapter: "odd number",
        },
      ],
      courseObject: [
        {
          name: "Course Introduction",
          chapters: [
            "hello world programme",
            "print even Number",
            "Palindrome code",
            "odd numbeee",
          ],
          showCollapse: false,
        },
        {
          name: "Python Setup",
          chapters: [
            "Course Introduction",
            " Why Python ?",
            "Course Curriculum Overview",
            "Course FAQs",
          ],
          // time: ["02.12", "03.25", "05.18", "10.08"],
          showCollapse: false,
        },
        {
          name: "Python Object and Data Structure Basics",
          chapters: [
            "Command Line Basics",
            " Running Python Code",
            "Getting the Notebooks and the Course Material",
            "Git and Github Overview (Optional)",
          ],
        },
        {
          name: "Python Statements",
          chapters: [
            "Numbers: Simple Arithmetic",
            " Variable Assignments",
            "Introduction to Strings",
            "Indexing and Slicing with Strings",
          ],
          showCollapse: false,
        },
        {
          name: "String Properties and Methods",
          chapters: [
            "Command Line Basics",
            " Running Python Code",
            "Getting the Notebooks and the Course Material",
            "Git and Github Overview (Optional)",
          ],
        },
        {
          name: "Lists in Python",
          chapters: [
            "Command Line Basics",
            " Running Python Code",
            "Getting the Notebooks and the Course Material",
            "Git and Github Overview (Optional)",
          ],
        },
      ],
      chapter: [],
    };
  },
  props: {
    selectedCourse: Object,
  },
  methods: {
    Course() {
      this.chapter = this.selectedCourse.chapter;
      // console.log(this.chapter.length);
    },
    getTopic(topic) {
      // console.log(topic);
      this.$store.commit("topic/SET_SELECTED_TOPIC", topic);
    },
    sortData() {
      if (this.chapter.length == 0) {
        this.$store.commit("topic/SET_SELECTED_TOPIC", "");
      } else {
        this.getTopic();
      }
    },
  },
  mounted() {
    this.Course();
    this.sortData();
  },
};
</script>
